import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from 'react-i18next'

import FetchFolderGateway from "../../../gateway/Folder/FetchFolderGateway"
import Loader from '../loader/Loader'
import { FolderDetail } from "../../../domain/Folder/Folder"
import { useQuery } from '../../../infrastructure/hooks'
import FormGateway from "../../../gateway/Form/FormGateway"
import Forms from "../../../domain/Form/Forms"
import GetFormsUseCase from "../../../useCase/Form/GetFormsUseCase"
import { ListAppearance } from "../button/AppearanceDropDown"
import FoldersDataList from "./FoldersDataList"
import EmptyFolders from "./EmptyFolders"

interface Props {
  term: string
  state: string | null
  formId: string | null
  viewMode: ListAppearance
}

const ITEMS_PER_PAGE = 10;

const PlateformeFoldersComponent = ({ term, state, formId, viewMode }: Props): JSX.Element => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [folders, setFolders] = useState<FolderDetail[] | null>(null);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [forms, setForms] = useState<Forms[]>([])
  const [sortConfig, setSortConfig] = useState<{ key: string, direction: 'asc' | 'desc' }>({
    key: 'date',
    direction: 'desc'
  });

  const query = useQuery();
  const history = useHistory();
  const currentPage = query.get('currentPage') || '1';
  const currentPageNumber = parseInt(currentPage, 10);

  const updateQueryParams = (params: { [key: string]: string }) => {
    const searchParams = new URLSearchParams(query);
    Object.keys(params).forEach(key => searchParams.set(key, params[key]));
    history.push({ search: searchParams.toString() });
  };

  useEffect(() => {
    const fetchFolders = async () => {
      setIsLoaded(false);
      const folderGateway = new FetchFolderGateway();
      const fetchedFolders = await folderGateway.getFoldersByPlateformeState(currentPageNumber, ITEMS_PER_PAGE, state, term, formId, sortConfig.key, sortConfig.direction);
      if (fetchedFolders.dossiers === null) {
        return;
      }

      setFolders(fetchedFolders.dossiers);
      setTotalItems(fetchedFolders.totalItems);
      setIsLoaded(true);
    };

    fetchFolders();
  }, [currentPageNumber, term, formId, sortConfig]);

  useEffect(() => {
    updateQueryParams({ currentPage: '1' });
  }, [term]);

  useEffect(() => {
    new GetFormsUseCase(new FormGateway()).execute().then(forms => {
      setForms(forms)
    })
  }, [])

  const handleDeleteFolder = (id: string): void => {
    if (!folders) return;
    setFolders(folders.filter(folder => folder.id !== id));
  };

  const requestSort = (key: string) => {
    let direction: 'asc' | 'desc' = 'asc';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  if (!isLoaded) {
    return <div className="flex-container">
      <div className="col-md-12">
        <Loader />
      </div>
    </div>
  }

  if (isLoaded && folders?.length === 0) {
    return <EmptyFolders />
  }

  return (
    <div className="flex-container">
      <div className="col-md-12">
        <FoldersDataList
          folders={folders ?? []}
          forms={forms}
          handleDeleteFolder={handleDeleteFolder}
          state={state}
          totalItems={totalItems}
          itemsPerPage={ITEMS_PER_PAGE}
          type={'manage'}
          viewMode={viewMode}
          requestSort={requestSort}
          sortConfig={sortConfig}
        />
      </div>
    </div>
  );
};

export default PlateformeFoldersComponent;